import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { RawMaterialTypesModel } from 'src/app/shared/entities/raw-material-types.model';
import { RawMaterialTypeService } from 'src/app/shared/services/app/raw-material-type.service';

@Component({
    selector: 'app-raw-material-types-add-edit',
    templateUrl: './raw-material-types-add-edit.component.html',
    styleUrls: ['./raw-material-types-add-edit.component.scss']
})
export class RawMaterialTypesAddEditComponent implements OnInit {

    public uid: string = null;
    public rawMaterialTypeModel: RawMaterialTypesModel = new RawMaterialTypesModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private rawMaterialTypeService: RawMaterialTypeService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

        return;
    }

    onCloseDialog(raw_material_type: RawMaterialTypesModel) {
        this.ref.close(raw_material_type);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.rawMaterialTypeModel.uid],
            name: [this.rawMaterialTypeModel.name, [Validators.required, Validators.maxLength(200)]],
        });
    }

    getItem(): void {
        this.loading = true;
        this.rawMaterialTypeService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.rawMaterialTypeModel.map(response.payload);
                this.form.patchValue(this.rawMaterialTypeModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.rawMaterialTypeService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.rawMaterialTypeModel.map(response.payload);
                this.form.patchValue(this.rawMaterialTypeModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Tipul de materie prima a fost salvata cu success!'
                });
                this.ref.close(this.rawMaterialTypeModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }
}
